import { useEffect, useState } from "react";
import TooltipConfig from "../Tooltip";
import "./styles.css";

const TitleComponent = ({
  title,
  width,
}: {
  title: string;
  width: number;
}) => {
  const [padding, setPadding] = useState<number>(0);

  useEffect(() => {
    if (width < 200) {
      setPadding(70);
    } else {
      setPadding(90);
    }
  }, []);

  return (
    <div>
      <div className="title-component">
          <div style={{ display: "inline-flex", justifyContent: "start" }}>
            <TooltipConfig
              content={[title]}
              children={
                <div
                  style={{ maxWidth: width - padding }}
                  className="text-overflow"
                >
                  {title}
                </div>
              }
              style={true}
            />
          </div>
        </div>
    </div>
  );
};

export default TitleComponent;
